import { render, staticRenderFns } from "./BaseFormCriteria.vue?vue&type=template&id=41b6f8a8&"
import script from "./BaseFormCriteria.vue?vue&type=script&lang=js&"
export * from "./BaseFormCriteria.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormCriteria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports